import { type Rating } from '@avanta/shared/types/psychologists';
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/common';
import { PsychologistService } from 'services/psychologists';
import { useUserStore } from 'stores/user';

const MAX_RATINGS = 20;

export const useFetchRating = (): {
  ratingList: Rating[];
  isLoading: boolean;
} => {
  const psychologistId = useUserStore(state => state.user?.id);
  const ratingList = useUserStore(state => state.user?.ratingList);

  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.FETCH_PSYCHOLOGIST_RATINGS, psychologistId],
    queryFn: () => PsychologistService.getPsychologistRatings(psychologistId ?? ''),
    select: response => response.data,
    enabled: !!psychologistId && !!ratingList && ratingList.length === MAX_RATINGS,
  });

  if (ratingList && ratingList.length < MAX_RATINGS) {
    return {
      ratingList,
      isLoading: false,
    };
  }

  return {
    ratingList: data ?? [],
    isLoading,
  };
};
